import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchVehiclesModel = () =>
  apiActionCreator({
    'endpoint': '/budgets/vehicles-models',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_MODEL,
      ActionTypes.FETCHED_VEHICLES_MODEL,
      [ActionTypes.FETCHED_VEHICLES_MODEL_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const deleteVehicleModel = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets/vehicles-models/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_VEHICLES_MODEL,
        [
          () => {
            return {
              'type': ActionTypes.DELETED_VEHICLES_MODEL,
              'payload': id,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro borrado'),
        ],
        [ActionTypes.DELETE_VEHICLES_MODEL_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const addVehiclesModels = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/budgets/vehicles-models/vehicles',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_VEHICLES_MODEL,
        [
          () => {
            dispatch(fetchVehiclesModel());
            return {
              'type': ActionTypes.ADDED_VEHICLES_MODEL,
            };
          },
          (response) => buildSuccessMessage(response, 'Registros Guardados'),
        ],
        [ActionTypes.ADDING_VEHICLES_MODEL_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const updateVehiclesModel = (data = {}, id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/budgets/vehicles-models/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_VEHICLES_MODEL,
        [
          () => {
            dispatch(fetchVehiclesModel());
            return {
              'type': ActionTypes.UPDATED_VEHICLES_MODEL,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Actualizado'),
        ],
        [ActionTypes.UPDATED_VEHICLES_MODEL_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};
